import { addLocaleData } from 'react-intl';
import messages from 'depop-locale/en.json';
import data from 'react-intl/locale-data/en';

addLocaleData(data);

export default messages;



// WEBPACK FOOTER //
// ../src/client/supportedLocales/en.js